import { Injectable, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutPortalService {
  private _portals = new Map<string | symbol, TemplateRef<HTMLElement>>();
  private _update$ = new Subject<undefined>();

  constructor() {}

  get update$(): Observable<undefined> {
    return this._update$;
  }

  addPortal(key: string | symbol, template: TemplateRef<HTMLElement>): void {
    this._portals.set(key, template);
    this._update$.next(undefined);
  }

  getPortal(key: string | symbol): TemplateRef<HTMLElement> | undefined {
    return this._portals.get(key);
  }

  destroyPortal(key: string | symbol): void {
    this._portals.delete(key);
    this._update$.next(undefined);
  }
}
